import type { TFunction } from 'i18next';

import yup from '../../../shared/validation';
import { RegistrationWizardStep } from './complete-registration.types';

const requiredPositiveMeasurement = (t: TFunction) =>
  yup
    .number()
    .transform((value, originalValue) =>
      originalValue === '' || originalValue === null ? undefined : value,
    )
    .typeError(t('formikValidation.valueRequired'))
    .required(t('formikValidation.valueRequired'))
    .moreThan(0, t('settings.measurements.valuePositive'));

export function getRegistrationNameValidation(t: TFunction) {
  return yup.object({
    firstname: yup
      .string()
      .max(256, t('formikValidation.maxLength').replace('{0}', '256'))
      .required(t('formikValidation.firstnameRequired'))
      .max(100, t('formikValidation.firstnameMax')),
    lastname: yup
      .string()
      .max(256, t('formikValidation.maxLength').replace('{0}', '256'))
      .required(t('formikValidation.lastnameRequired'))
      .max(100, t('formikValidation.lastnameMax')),
  });
}

export function getRegistrationMeasurementsValidation(t: TFunction) {
  return yup.object({
    weightValue: requiredPositiveMeasurement(t),
    heightValue: requiredPositiveMeasurement(t),
  });
}

export function getRegistrationVisualizationValidation(t: TFunction) {
  return yup.object({
    language: yup
      .object()
      .nullable()
      .required(t('formikValidation.languageRequired')),
  });
}

export function getRegistrationStepValidation(
  step: RegistrationWizardStep,
  t: TFunction,
) {
  switch (step) {
    case RegistrationWizardStep.name:
      return getRegistrationNameValidation(t);
    case RegistrationWizardStep.measurements:
      return getRegistrationMeasurementsValidation(t);
    case RegistrationWizardStep.visualization:
      return getRegistrationVisualizationValidation(t);
    default:
      return yup.object({});
  }
}

export const getRegistrationCompletionValidation =
  getRegistrationNameValidation;
